import { TopUpEffect } from "./TopUpEffect";

export class TopUpVFX extends Phaser.GameObjects.Container {
    private coinsEffects: TopUpEffect[];

    constructor(scene: Phaser.Scene, numCoinsEffect: number, frame: string, end: { x: number, y: number }, spread: { min: number, max: number }) {
        super(scene)
        this.scene = scene;

        this.scene = scene;
        this.coinsEffects = [];

        for (let i = 0; i < numCoinsEffect; i++) {
            const coinsEffect = new TopUpEffect(this.scene, frame, end, spread);
            this.coinsEffects.push(coinsEffect);
            this.add(coinsEffect)
        }
    }

    showTime(startPoint: { x: number, y: number }) {
        this.coinsEffects.forEach(coin => coin.action(startPoint))
    }
}
